<template>
  <el-dialog
    v-el-drag-dialog
    :visible="visible"
    width="800px"
    :close-on-click-modal="false"
    append-to-body
    :title="$t('CargoMsg.Cargo_VGMLog')"
    :before-close="toCancel"
  >
    <div class="section row-grid" style="height:350px;padding:0">
      <cargo-ag-grid
        no="logGrid"
        config-module="150115"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%; min-height: 345px;"
      />
    </div>
    <span slot="footer" style="padding:10px">
      <el-button no="toCancel" @click="toCancel">{{ $t('SeaExport.Close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { queryVgmLog } from '@/api/seaExport/vgm'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import { VGM_YGT_STATES } from '@/class/cargo/model/parameters/SeaExportConstants'

export default {
  name: 'VgmLog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true },
    seaHouseCache: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      storageURL: '',
      gridOptions: {
        singleClickEdit: true,
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('SeaExport.RefNo'),
          colId: 'referenceNo',
          field: 'referenceNo',
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNo',
          field: 'containerNo',
          flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SendDate'),
          colId: 'dateCreated',
          field: 'dateCreated',
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.ReceiptTime'),
          colId: 'dateModified',
          field: 'dateModified',
          flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ShippingCompanyReceiptStatus'),
          colId: 'state',
          field: 'state',
          valueFormatter: params => {
            for (const data of SeaExportConstants.VGM_RECEIPTS) {
              if (data.code === params.value) {
                return data.chineseName
              }
            }
            return ''
          },
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.StationStatus'),
          colId: 'ygtState',
          field: 'ygtState',
          valueFormatter: params => {
            for (const data of SeaExportConstants.VGM_YGT_STATES) {
              if (data.code === params.value) {
                return data.chineseName
              }
            }
            return ''
          },
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.ReceiptContent'),
          colId: 'content',
          field: 'content',
          flex: 1
        },
        // {
        //   headerName: this.$t('SeaExport.SendingChannelVgm'),
        //   colId: 'vgmChannel',
        //   field: 'vgmChannel',
        //   flex: 1,
        //   cellRenderer: (params) => {
        //     return ColumnUtils.vgmChannelLabelFunc(params.value)
        //   }
        // },
        {
          headerName: this.$t('SeaExport.Operation'),
          colId: 'fileId',
          field: 'fileId',
          cellRenderer: (params) => {
            if (params.value) {
              return `<a href="${URL.common.findByFileId}/${params.value}?sessionId=${this.$store.getters.token}" target="_blank" style="color:blue">${this.$t('FileHistory.fileDownload')}</a>`
            } else {
              return ''
            }
          },
          flex: 1
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'),
          hide: true,
          colId: 'thirdPartyCarrier',
          field: 'thirdPartyCarrier',
          valueFormatter: params => {
            const field = params.data.portOfLoading === '上海' ? 'shPorts' : 'externalPorts'
            console.info(this.seaHouseCache)
            for (const data of this.seaHouseCache[field]) {
              if (data.code === params.value) {
                return data.chineseName
              }
            }
            return ''
          }
        },
        {
          headerName: 'MBL NO.',
          hide: true,
          colId: 'mbl',
          field: 'mbl'
        },
        {
          headerName: this.$t('SeaExport.PortOfLoading'),
          hide: true,
          colId: 'portOfLoading',
          field: 'portOfLoading'
        },
        {
          headerName: this.$t('SeaExport.Vessel'),
          hide: true,
          colId: 'vessel',
          field: 'vessel'
        },
        {
          headerName: this.$t('SeaExport.Voyage'),
          hide: true,
          colId: 'voyage',
          field: 'voyage'
        },
        {
          headerName: this.$t('SeaExport.Wharf'),
          hide: true,
          colId: 'wharf',
          field: 'wharf',
          valueFormatter: params => {
            for (const data of this.seaHouseCache.wharfs) {
              if (data.code === params.value) {
                return data.chineseName
              }
            }
            return ''
          }
        },
        {
          headerName: 'SO NO.',
          hide: true,
          colId: 'soNo',
          field: 'soNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerHolder'),
          hide: true,
          colId: 'boxHolder',
          field: 'boxHolder',
          valueFormatter: params => {
            for (const data of SeaExportConstants.BOX_HOLDERS) {
              if (data.code === params.value) {
                return data.chineseName
              }
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VGMCutOffDate'),
          hide: true,
          colId: 'vgmCutOffDate',
          field: 'vgmCutOffDate'
        },
        {
          headerName: this.$t('SeaExport.VgmWeight'),
          hide: true,
          colId: 'vgmWeight',
          field: 'vgmWeight'
        },
        {
          headerName: this.$t('SeaExport.VgmWeighingMethod'),
          hide: true,
          colId: 'vgmWeightingMethod',
          field: 'vgmWeightingMethod'
        },
        {
          headerName: this.$t('SeaExport.VGMLLC'),
          hide: true,
          colId: 'vgmLiabilityCompany',
          field: 'vgmLiabilityCompany'
        },
        {
          headerName: this.$t('SeaExport.VGMWeightAddress'),
          hide: true,
          colId: 'weighingAddress',
          field: 'weighingAddress'
        },
        {
          headerName: this.$t('SeaExport.VGMSignature'),
          hide: true,
          colId: 'vgmAutoGraph',
          field: 'vgmAutoGraph'
        }
      ]
    }
  },
  async created() {
    this.init()
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
  },
  methods: {
    init() {
      if (!this.jobUuid) {
        return
      }
      this.loading = getLoading()
      queryVgmLog({ jobUud: this.jobUuid }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    toCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
